import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号' , width : 75},
    {key:'listenOrgName', label: '评价人部门' , width : 120 },
    {key:'listenEmployeeName', label: '评价人姓名' , width : 120},
    {key:'listenEmployeeCode', label: '评价人工号' , width : 120},
    {key:'listenedEmployeeName', label: '被评价人姓名', width : 120 },
    {key:'listenedEmployeeCode', label: '被评价人工号' , width : 120},
    {key:'listenTypeDesc', label: '评价类型', width : 100},
    {key:'listenedTypeDesc', label: '被评价类型', width : 100},
    {key:'limitCount', label: '可评次数',width : 100},
    {key:'expiryDate' , label : '截止日期',width : 100},
    {key:'termName', label: '所属学期',width : 100}
    
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId,
        queryType : '1'
    };
    var params = [];
    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        }  else if(i === 'order'){
            params.push(`order=${keywords[i]}`);
        } else {
        }
    }
    return fetch.post('/listen/generate/query?'+ params.join('&'),  Object.assign(defaultsParams, keywords))
    // return fetch.mockget('http://test.gxjxcp.com:8888/mock/11/jxcp-webapp/listenManager')
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({ 
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchTerm = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.get('listen/org/copy', keywords)
    .then(response => response.payload.meta.extParams || {})
    .then(params => params.lastTerm || {})
    .then(lastTerm => lastTerm.id)
}

const querySearchBySelectId = () => {
    return fetch.get('/listen/generate/getBySelf/').then(response => {
        return response.payload.data;
    })
}

const checkListend = (data) => {
    return fetch.post('/listen/generate/checkListend', data)
}

/**
 * @method insert
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('/listen/assign/insert', data)
    .then(response => {
        if(response.code === 200) {
            message.success('温馨提示：添加成功！');
        }
    });
}

/**
 * @method copy
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const copy = (params) => {
    return fetch.post('listen/org/save/copy', params)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
            DataGrid.refresh();
        }
    }).catch(error => {
        return error;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (params) => {
    return fetch.post('/listen/generate/delete',params );
    // .then(response => {
    //     return response;
    // }).catch(error => {
    //     return error;
    // });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (params) => {
    if(DataGrid.selections.length === 0) {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '未勾选任何一项，将删除查询的所有记录！',
            onOk() {
                 remove(params);
                // remove(params).then(response => {
                //     // if(response.code === 200) {
                //     //     message.success(response.message);
                //     //     // DataGrid.refresh();
                //     // }
                //     return response;
                // });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
        // Modal.error({
        //     title: '请先选择一项或多项！',
        //     content: '只有勾选一项或多项后才能删除！',
        // });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '确定删除该记录！',
            onOk() {
                 remove({listenIds : DataGrid.selections});
                // remove({listenIds : DataGrid.selections}).then(response => {
                //     // if(response.code === 200) {
                //     //     message.success(response.message);
                //     //     // DataGrid.refresh();
                //     // }
                //     return response;
                // });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'listen/assign'+ url;
};
const update = (id , data) => {
    return fetch.post('/listen/generate/update/'+id, data)
}

const batchUpdate = (data) => {
    return fetch.post('/listen/generate/update', data)
}
const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    insert,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    update,
    batchUpdate,
    querySearchTerm,
    querySearchBySelectId,
    checkListend,
    copy,
    getSelection
}